import * as actions from "../actionTypes"

// show tooltips indicator for diagrams - global setting
const initialState = {
    value: true,
}

export default function showTooltipsIndicator(state = initialState, action) {
    switch (action.type) {
        case actions.SET_SHOW_TOOLTIPS_INDICATOR: {
            return {
                ...state,
                value: action.payload.value,
            }
        }

        default:
            return state
    }
}
